import { computed } from 'vue'

import type { KanbanLogActor } from '@entities/kanban-comment'

import { useAdminRoutes } from '@shared/lib/routes'

interface KanbanLogAssigneePayload {
  oldAssignee: KanbanLogActor | null | undefined
  newAssignee: KanbanLogActor | null | undefined
}

interface AssigneeRef {
  name: string
  url: string
}

interface KanbanLogAssigneeReturn {
  refOldAssignee: ComputedRef<AssigneeRef | null>
  refNewAssignee: ComputedRef<AssigneeRef | null>
}

const buildAssignee = (assignee: KanbanLogActor | null | undefined): AssigneeRef | null => {
  if (!assignee) return null
  return {
    name: assignee.name,
    url: useAdminRoutes('admin.user.show', { user_id: assignee.id }) ?? '',
  }
}

export const useKanbanLogAssignee = (payload: KanbanLogAssigneePayload): KanbanLogAssigneeReturn => {
  const refOldAssignee = computed<AssigneeRef | null>(() => buildAssignee(payload.oldAssignee))
  const refNewAssignee = computed<AssigneeRef | null>(() => buildAssignee(payload.newAssignee))

  return {
    refOldAssignee,
    refNewAssignee,
  }
}